import React from "react";
import Tabs from '../Tabs/Tabs';
import PaymentLogPresenterWorkspace from "./PaymentLogPresenterWorkspace";
import numeral from "numeral";

class PaymentLogPresenter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'general',
    };
    this.formatCurrency = this.formatCurrency.bind(this)
    this.onChange = this.onChange.bind(this);
  };

  render() {
    return(
      <div className="payment-log">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <div className="tab-content">
            <PaymentLogPresenterWorkspace
            activeTab={this.state.activeTab}
              {...this.props}
              timeline={this.props.payment_log.timeline}
              formatCurrency={this.formatCurrency}
              capitalizeFirstLetter={this.capitalizeFirstLetter}
              read_only={true}
              payment_channel={this.props.payment_log.payment_channel ? this.props.payment_log.payment_channel : null}
              />
          </div>
        </div>
      </div>
    );
  };

  tabs() {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.activeTab === 'general' ? 'active' : null,
          changeHandler: this.onChange,
        },
        {
          tabName: I18n.t('notes'),
          targetName: 'notes',
          classes: this.state.activeTab === 'notes' ? 'active' : null,
          changeHandler: this.onChange,
        }
      ]
    );
  };

  onChange(value) {
    this.setState({
      activeTab: value,
    });
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
};

export default PaymentLogPresenter